import { resolveApiBaseUrl } from '../utils/apiBase';
import { ensureCsrfCookie, xsrfHeaders } from './authApi';

const API = () => resolveApiBaseUrl();

async function jsonFetch(path, options = {}) {
  await ensureCsrfCookie();
  const response = await fetch(`${API()}${path}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...xsrfHeaders(),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
    ...options,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Request failed (${response.status})`);
  }
  if (response.status === 204) return null;
  return response.json();
}

export async function submitCopyrightRequest(payload) {
  return jsonFetch('/copyright/requests', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function listCopyrightRequests(status) {
  const q = status && status !== 'all' ? `?status=${encodeURIComponent(status)}` : '';
  return jsonFetch(`/v1/admin/copyright-requests${q}`);
}

export async function patchCopyrightRequest(id, payload) {
  return jsonFetch(`/v1/admin/copyright-requests/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
